import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-signature {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${dt('appSignature.gap')};

  & .label {
    color: ${dt('appSignature.label.color')};
    font-weight: ${dt('appSignature.label.fontWeight')};
    font-size: ${dt('appSignature.label.fontSize')};
  }

  & .signature-canvas-wrapper {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    background: ${dt('appSignature.canvas.background')};
    border: 1px solid ${dt('appSignature.canvas.borderColor')};
    box-shadow: ${dt('appSignature.canvas.shadow')};
    border-radius: ${dt('appSignature.canvas.borderRadius')};
    transition: border-color 0.2s, background-color 0.2s;
  }

  & .signature-canvas-wrapper:focus,
  & .signature-canvas-wrapper:focus-visible,
  & .signature-canvas-wrapper:focus-within {
    outline: none;
  }

  & .signature-canvas-wrapper.has-signature {
    background: ${dt('appSignature.canvas.filled.background')};
  }

  & .signature-canvas-wrapper:hover:not(.is-disabled):not(.is-invalid):not(:focus-within) {
    border-color: ${dt('appSignature.canvas.hover.borderColor')};
  }

  & .signature-canvas-wrapper.is-invalid {
    border-color: ${dt('appSignature.canvas.invalid.borderColor')};
  }

  & .signature-canvas-wrapper.is-invalid .canvas-placeholder {
    color: ${dt('appSignature.placeholder.invalid.color')};
  }

  & .signature-canvas-wrapper:focus-within:not(.is-disabled) {
    border-color: ${dt('appSignature.canvas.focus.borderColor')};
  }

  & .signature-canvas-wrapper.is-disabled {
    background: ${dt('appSignature.canvas.disabled.background')};
    border-color: ${dt('appSignature.canvas.disabled.borderColor')};
  }

  & .signature-canvas-wrapper.is-disabled.is-invalid {
    border-color: ${dt('appSignature.canvas.invalid.borderColor')};
  }

  & .signature-canvas-wrapper canvas {
    display: block;
    width: 100%;
    height: ${dt('appSignature.canvas.height')};
    background: transparent;
    border: none;
    touch-action: none;
  }

  & .canvas-placeholder {
    position: absolute;
    bottom: 8px;
    right: 8px;
    color: ${dt('appSignature.placeholder.color')};
    font-size: ${dt('appSignature.placeholder.fontSize')};
    font-weight: ${dt('appSignature.placeholder.fontWeight')};
    line-height: ${dt('appSignature.placeholder.lineHeight')};
    pointer-events: none;
    z-index: 1;
  }

  & .clear-signature-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: ${dt('appSignature.canvas.borderRadius')};
    transition: background-color 0.2s;
    z-index: 10;
    color: ${dt('appSignature.clearButton.color')};
    font-size: ${dt('appSignature.placeholder.fontSize')};
    font-weight: 500;
  }

  & .clear-signature-btn:hover {
    background-color: ${dt('appSignature.clearButton.hoverBackground')};
  }

  & .clear-signature-btn i {
    font-size: 16px;
    text-decoration: none !important;
    font-style: normal;
  }
}`;
